module.exports = __webpack_public_path__ + "static/media/2_pl.b48ac6b0.png";